import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "./api";

export function useList(path, params) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(path, { params: JSON.parse(key) });
      setItems(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }, [path, key]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { items, loading, reload };
}

export function useFormState(initial) {
  const [form, setForm] = useState(initial);
  const set = (k) => (v) => setForm((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));
  return { form, setForm, set };
}
